// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inset-shadow[data-v-5ceb96ec] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  box-shadow: inset 0px 0px 4px #939393;\n  height: 100%;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
